var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { Portal } from 'react-portal';
import { registerClass, cns, getContext, subClass } from '@food/css-manager';
// il contatore di modal aperte all'interno di una stessa applicazione
var counter = 0;
var topContainer = registerClass(function (t) { return "\n\toverflow-y: auto;\n\tmax-height: 100vh;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: " + (t.zIndexes.P4_Modal - 1) + ";\n"; }, false);
var modalBackground = registerClass(function (t, sc) { return "\n\tbackground-color: rgba(0, 0, 0, " + t.dimmerOpacity + ");\n\tmin-height: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: " + t.ratios.xl * 2 * t.font.baseSize + "px;\n\tjustify-content: center;\n\tanimation-name: fadeIn;\n\tanimation-duration: " + t.timings.base / 1000 + "s;\n\tanimation-fill-mode: both;\n\t@keyframes fadeIn {\n\t\tfrom {\n\t\t\topacity: 0;\n\t\t}\n\t\tto {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t\n\t&." + sc('fullscreen') + " {\n\t\tpadding: 0;\n\t}\n"; });
var modalBody = registerClass(function (t, sc) { return "\n\twidth: 90%; // Lascia un minimo di bordo\n\tmax-width: 900px; // FIXME\n\tbackground-color: " + t.colors.white + ";\n\tbox-shadow: " + t.boxShadow(2) + ";\n\toverflow: visible;\n\tz-index: " + t.zIndexes.P4_Modal + ";\n\tposition: relative;\n\t\n\t&." + sc('fullscreen') + " {\n\t\twidth: 100%;\n\t\tmax-width: unset;\n\t\tmin-height: 100vh;\n\t}\n\n\tp,\n\tul,\n\tol {\n\t\tmargin-bottom: " + (t.ratios.xl / 2) * t.font.baseSize + "px;\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\n\tul,\n\tol {\n\t\tlist-style: disc;\n\t\tpadding-left: 1em;\n\n\t\tli {\n\t\t\tmargin-bottom: " + (t.ratios.s / 2) * t.font.baseSize + "px;\n\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\tol {\n\t\tlist-style: decimal;\n\t}\n"; });
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.backgroundRef = React.createRef();
        return _this;
    }
    Modal.prototype.componentDidUpdate = function (oldProps) {
        // all'apertura di una modal devo sicuramente rimuovere lo scroll dal body
        var open = this.props.open;
        var oldOpen = oldProps.open;
        if (open && !oldOpen) {
            counter += 1;
            document.body.style.overflowY = 'hidden';
        }
        else if (!open && oldOpen) {
            counter -= 1;
            // il contatore a 0 significa che nessuna modal e' aperta nell'applicazione, quindi devo riattivare lo scroll del body
            document.body.style.overflowY = 'auto';
        }
    };
    Modal.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, children = _a.children, zIndex = _a.zIndex, _b = _a.className, className = _b === void 0 ? '' : _b, closeHandler = _a.closeHandler, fullscreen = _a.fullscreen;
        var cssContext = getContext();
        if (open !== true) {
            return null;
        }
        return (React.createElement(Portal, null,
            React.createElement("div", { className: cns.apply(void 0, __spreadArrays([topContainer,
                    className], cssContext.portalClasses, [fullscreen && subClass(topContainer, 'fullscreen')])), ref: this.backgroundRef, style: { zIndex: zIndex } },
                React.createElement("div", { className: cns(modalBackground, fullscreen && subClass(modalBackground, 'fullscreen')), onClick: function (evt) {
                        if (evt.target === _this.backgroundRef.current &&
                            closeHandler) {
                            closeHandler();
                        }
                    } },
                    React.createElement("div", { className: cns(modalBody, fullscreen && subClass(modalBody, 'fullscreen')) }, children)))));
    };
    return Modal;
}(React.PureComponent));
export { Modal };
//# sourceMappingURL=Modal.js.map